var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9V7C18 3.6 15.4 1 12 1C8.6 1 6 3.6 6 7V9C4.3 9 3 10.3 3 12V20C3 21.7 4.3 23 6 23H18C19.7 23 21 21.7 21 20V12C21 10.3 19.7 9 18 9ZM8 7C8 4.8 9.8 3 12 3C14.2 3 16 4.8 16 7V9H8V7ZM19 20C19 20.6 18.6 21 18 21H6C5.4 21 5 20.6 5 20V12C5 11.4 5.4 11 6 11H18C18.6 11 19 11.4 19 12V20Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconLock.366ad4da16b176dc30f05691878b7709.svg";